var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21140_177044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5339 6.66373C14.8384 8.15793 14.6214 9.71135 13.9192 11.0649C13.2169 12.4185 12.0719 13.4904 10.675 14.1019C9.27803 14.7135 7.7137 14.8276 6.24281 14.4253C4.77193 14.023 3.48341 13.1287 2.59213 11.8913C1.70085 10.654 1.26069 9.14856 1.34505 7.62599C1.42941 6.10342 2.0332 4.65579 3.05571 3.52451C4.07823 2.39323 5.45767 1.64668 6.96399 1.40937C8.47031 1.17205 10.0125 1.4583 11.3333 2.2204",
    stroke: "#007A02",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33073L8 9.33073L14.6667 2.66406",
    stroke: "#007A02",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21140_177044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/AlertSuccess.61620446444c3afcfb1ab4af8affabe2.svg";
export { ForwardRef as ReactComponent };